export default __webpack_public_path__ + "static/media/PowerSupply.70d33884.svg";